/* eslint-disable */
import { supabase } from "../supabase";

export function useFavorites({ favorites, setFavorites, userId }) {
  const toggleFavorite = (id, type = "catalog") => {
    setFavorites(prev => {
      const next = { ...prev };
      const key = `${type}_${id}`;
      if (next[key]) delete next[key];
      else next[key] = { id, type, at: new Date().toISOString() };
      try { localStorage.setItem("clb_favorites", JSON.stringify(next)); } catch(e) { if (process.env.NODE_ENV !== 'production') console.warn('[localStorage:favorites_toggle]', e?.message || e); }
      supabase.from("user_profiles").select("preferences").eq("id", userId).single()
        .then(({ data }) => { const prefs = data?.preferences || {}; supabase.from("user_profiles").update({ preferences: { ...prefs, favorites: next } }).eq("id", userId); });
      return next;
    });
  };
  const isFav = (id, type = "catalog") => !!favorites[`${type}_${id}`];
  return { toggleFavorite, isFav };
}

